import React, { FC, useEffect, useState } from 'react'
import { SelectDropArrow } from '../../../constants/svg'
import { internalLinkHandler } from '../../../utils/link.utils'
import Button from '../button'
import { CommonStickyNavOuter } from './style'

type Item = {
  id: string
  buttonId: string
  text: string
}

type CommonStickyNavProps = {
  data: {
    items: Item[]
  }
  stickyNavCta: any
}

const CommonStickyNav: FC<CommonStickyNavProps> = ({ data, stickyNavCta }) => {
  const { items } = data || { items: [] } // Ensure items is not nul
  const [ActiveState, setActiveState] = useState(0)
  const [stickyNavTabText, setStickyNavTabText] = useState('')
  const [NavListVisible, setNavListVisible] = useState(false)

  let mainNavbarHeight: number = 0
  let sticky: number = 0
  let stickyHeight: number = 0
  let mainNavbar =
    typeof document !== 'undefined' && document.querySelector('nav[data-cy = fullHeader]')
  let navbarSticky = typeof document !== 'undefined' && document.getElementById('ipStickyNav')

  useEffect(() => {
    let spanEle = document.querySelectorAll('span[id]')
    let mainNavbar = document.querySelector('nav[data-cy = fullHeader]')
    let navbarSticky = document.getElementById('ipStickyNav')
    if (mainNavbar) {
      mainNavbarHeight = mainNavbar ? mainNavbar.clientHeight : 0
    }

    const handleScroll = () => {
      // Calculate scroll position
      const scrollY = window.scrollY + 30
      spanEle.forEach((ele: any, index: number) => {
        let top = ele.offsetTop - mainNavbarHeight
        if (scrollY >= top) {
          setActiveState(index)
          renderTextOnScroll(index)
        }
      })
    }

    // Add scroll event listener when component mounts
    window.addEventListener('scroll', () => {
      const winYOffset = window.pageYOffset + mainNavbarHeight
      if (navbarSticky) {
        sticky = navbarSticky ? navbarSticky.offsetTop : 0
      }

      if (winYOffset >= sticky) {
        navbarSticky?.classList.add('sticky')
      } else {
        navbarSticky?.classList.remove('sticky')
      }

      handleScroll()
    })

    // Clean up the scroll event listener when component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [sticky])

  const toggleTab = (event: any, index: number) => {
    const dataTarget = event.target.dataset.tab
    setActiveState(index)
    scrollToSection(dataTarget)
    setNavListVisible(!NavListVisible)
  }

  const getActiveClass = (index: number, className: string) =>
    ActiveState === index ? className : ''

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    if (mainNavbar) {
      mainNavbarHeight = mainNavbar ? mainNavbar.clientHeight : 0
    }

    if (navbarSticky) {
      stickyHeight = navbarSticky ? navbarSticky.clientHeight : 0
    }
    if (element) {
      let minusHeight = 0
      if (screen.width <= 768) {
        minusHeight = mainNavbarHeight
      } else {
        minusHeight = stickyHeight - 64
      }

      window.scrollTo({
        top: element.offsetTop - minusHeight,
        behavior: 'smooth',
      })
    }
  }

  const renderTextOnScroll = (activeTab: number) => {
    items.map((item, index) => {
      if (index === activeTab) {
        setStickyNavTabText(item.text)
      }
    })
  }

  const toggleNavList = () => {
    setNavListVisible(!NavListVisible)
  }

  return (
    <CommonStickyNavOuter id="ipStickyNav">
      <div className="NavListDropMenu" onClick={toggleNavList}>
        {stickyNavTabText} <SelectDropArrow />
      </div>

      <ul className={`NavList ${NavListVisible ? 'toggle' : ''}`}>
        {items.map((item, index) => {
          if (index <= 5) {
            return (
              <li
                key={index}
                className={`item ${getActiveClass(index, 'active')}`}
                data-tab={item.buttonId}
                onClick={event => toggleTab(event, index)}>
                {item.text}
              </li>
            )
          }
        })}
        {stickyNavCta && (
          <li className="StickyNavCtaDropMenu">
            <Button
              icon={true}
              href={
                stickyNavCta?.internalLink
                  ? internalLinkHandler(stickyNavCta?.internalLink)
                  : stickyNavCta?.externalUrl
              }
              text={stickyNavCta?.text}
              type="text-link"
              size="small"
              theme=""
            />
          </li>
        )}
      </ul>
    </CommonStickyNavOuter>
  )
}
export default CommonStickyNav
